export enum ListingViewStatus {
  PUBLISHED = 'published',
  EXPIRED = 'expired',
  PREVIEW = 'preview',
}
